import { createRouter, createWebHistory } from 'vue-router'
import FinderStep1 from '@/components/FinderStep1'
import FinderStep2 from '@/components/FinderStep2'
import FinderStep3 from '@/components/FinderStep3'
import FinderStep4 from '@/components/FinderStep4'
import FinderStep5 from '@/components/FinderStep5'
import FinderStepFinal from '@/components/FinderStepFinal'

const routes = [
  {
    path: '/',
    redirect: '/step1'
  },
  {
    path: '/step1',
    name: 'Weinfinder - Step 1',
    component: FinderStep1,
    index: 0
  },
  {
    path: '/step2',
    name: 'Weinfinder - Step 2',
    component: FinderStep2
  },
  {
    path: '/step3',
    name: 'Weinfinder - Step 3',
    component: FinderStep3
  },
  {
    path: '/step4',
    name: 'Weinfinder - Step 4',
    component: FinderStep4
  },
  {
    path: '/step5',
    name: 'Weinfinder - Step 5',
    component: FinderStep5
  },
  {
    path: '/step6',
    name: 'Weinfinder - Step 6',
    component: FinderStepFinal
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/step1'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
